import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const latLong = [-104.79786999211731, 40.04592359245807];
const key = 'pk.eyJ1IjoibWFtbW90aGdyYXBoaWNzIiwiYSI6ImNsOXlsbGNqeTA2MWMzcHFvMWloYmNubzYifQ.TQaXGUurb3sfmsGrGycECA';

mapboxgl.accessToken = key;

const map = new mapboxgl.Map({
  container: 'map', // container ID
  style: 'mapbox://styles/mapbox/dark-v10', // style URL
  center: latLong, // starting position [lng, lat]
  zoom: 8, // starting zoom
  projection: 'globe', // display the map as a 3D globe
});

map.on('style.load', () => {
  map.setFog({}); // Set the default atmosphere style
});

const geojson = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-104.79786999211731, 40.04592359245807],
      },
      properties: {
        title: 'Mammoth Graphics',
        description: 'Fort Lupton, Colorado.',
      },
    },
  ],
};

const markerElement = document.createElement('div');
markerElement.className = 'marker';

new mapboxgl.Marker(markerElement).setLngLat(geojson.features[0].geometry.coordinates).addTo(map);

const nav = new mapboxgl.NavigationControl();
map.addControl(nav, 'bottom-right');
